import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { Popover, TableCell } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import useRole from 'hooks/useRole';
import { ToastTopHelper } from 'utils/utils';

import DialogTransferOwnerCertificate from './DialogTransferOwnerCertificate';
import useStyles from './styles';

const TableCertificateAction = ({ setIsShowCertificateView, certificate }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isArtist, isCollector } = useRole();

  const [anchorEl, setAnchorEl] = useState(null);
  const [isShowTransferOwner, setIsShowTransferOwner] = useState(false);

  const open = Boolean(anchorEl);

  const handleOpenPopover = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleShowCertificateView = () => {
    setIsShowCertificateView(true);
    setAnchorEl(null);
  };

  const handleOpenTransferOwner = () => {
    setIsShowTransferOwner(true);
    setAnchorEl(null);
  };

  const handleCloseTransferOwner = () => {
    setIsShowTransferOwner(false);
  };

  const handleSubmitTransferOwner = () => {
    ToastTopHelper.success(t('send_request'));
    setIsShowTransferOwner(false);
  };

  const canTransferOwner = isCollector || (isArtist && certificate?.is_artist_owner_certificate);

  return (
    <TableCell className={classes.tableCell}>
      <MoreHorizOutlinedIcon
        onClick={handleOpenPopover}
        className={classes.iconOutLine}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className={classes.popover}
      >
        <Text
          type="sm"
          clickAble
          className={clsx(classes.textItemPopover)}
          onClick={handleShowCertificateView}
        >
          {t('view_certificate')}
        </Text>
        {canTransferOwner && (
          <Text
            type="sm"
            className={clsx(classes.textItemPopover)}
            onClick={handleOpenTransferOwner}
            clickAble
          >
            {t('tranfer_owner')}
          </Text>
        )}
      </Popover>

      <DialogTransferOwnerCertificate
        open={isShowTransferOwner}
        onClose={handleCloseTransferOwner}
        onSubmit={handleSubmitTransferOwner}
        certificate={certificate}
      />
    </TableCell>
  );
};

export default TableCertificateAction;
